import React from 'react';
import { useAtom } from 'jotai';
import TunesIcon from '@/components/Icons/TunesIcon';
import moment from 'moment/moment';
import { DEFAULT_SCHEDULE, RADIO_COLORS } from '@/config/constants';
import { activeRadioAtom, activeScheduleAtom } from '../../store';

export interface ScheduleCardProps {
  playingAt: number;
  hideImage?: boolean;
}

const ScheduleCard: React.FC<ScheduleCardProps> = ({ playingAt, hideImage = false }) => {
  const [activeSchedule] = useAtom(activeScheduleAtom);
  const [activeRadio] = useAtom(activeRadioAtom);
  const playing = moment(new Date(playingAt));
  const day = playing.locale('en').format('dddd');
  const time = playing.locale('en').format('HH:mm');

  const currentShows = activeSchedule.filter((s) => s.weekday === day && s.timeFrom <= time && s.timeTo > time);
  let currentShow = DEFAULT_SCHEDULE;
  const colors = activeRadio?.id && activeRadio?.id in RADIO_COLORS ? RADIO_COLORS[activeRadio?.id] : RADIO_COLORS[''];
  if (currentShows.length) {
    currentShow = currentShows[0];
  }

  return (
    <div className="flex flex-row items-center">
      <div
        className={`col-auto mr-0 flex items-center justify-items-center ${
          hideImage ? 'collapse hidden' : 'hidden md:flex lg:pr-4'
        }`}
      >
        {currentShow.photo ? (
          <div className={`flex items-center`} style={{ height: '60px' }}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={`https://www.visir.is/mi/300x300${currentShow.photo}`}
              alt={currentShow.description}
              className="pointer-events-none rounded-4"
              style={{ width: '61' }}
              width={61}
            />
          </div>
        ) : (
          <TunesIcon primaryColor={colors.primary} secondaryColor={colors.secondary} />
        )}
      </div>
      <div className={`lg:mw-48 my-auto block ${hideImage ? 'hidden' : 'md:hidden lg:block'}`}>
        <div className={'text-matte-black font-bold'}>{currentShow.title}</div>
        <div className={'text-gray-500'}>
          {currentShow.timeFrom ? `${currentShow.timeFrom} - ${currentShow.timeTo}` : 'Allan sólarhringinn'}
        </div>
      </div>
    </div>
  );
};

export default ScheduleCard;
